import { Typography, WithStyles, withStyles } from "@material-ui/core";
import { styles } from "../admin/EmptyOrderView.styles";
import React from "react";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { useLocation } from "react-router-dom";

export interface IMultipleSubscriptionsSuccessViewProps extends WithStyles<typeof styles> {}

const SalesRegistrationSuccessViewPure: React.FunctionComponent<IMultipleSubscriptionsSuccessViewProps> = ({
    classes
}) => {
    const location = useLocation();

    const isNewUserCreated = location?.state === "new";
    return (
        <CenteredContainer>
            <div className={classes.title}>
                <Typography variant="h2">{isNewUserCreated && "User registration & "} Trial subscription entitlement</Typography>
            </div>
            <Typography variant="h3">Success!</Typography>
            {isNewUserCreated && <Typography variant="body1">A new user has been registered.</Typography>}
            <Typography variant="body1">The user has been entitled to subscription(s).</Typography>
        </CenteredContainer>
    );
};

export const SalesRegistrationSuccessView = withStyles(styles)(SalesRegistrationSuccessViewPure);
